import { FC } from 'react';
import { Button } from 'antd';
import { TbX } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PreferenceModalHeader } from '@/shared/components/modals/PreferenceModalPrimitives';
import { SetStateMethod } from '@/types';

import { OAuthApplication, OAuthApplicationModalView } from '../../types';
import CreateOAuthApplication from './views/01-Create';
import ManageOAuthApplications from './views/02-Manage';

interface ContentProps {
    view: OAuthApplicationModalView;
    setOpen: SetStateMethod<boolean>;
    onCreated?: (oauthApplication: OAuthApplication) => void;
}

const Content: FC<ContentProps> = ({ view, setOpen, onCreated }) => {
    const { token } = useAntDesignTheme();

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <PreferenceModalHeader
                title={view === 'add' ? 'Create OAuth Application' : 'Manage OAuth Applications'}
                extra={
                    <Button
                        aria-label='Close OAuth applications modal'
                        size='small'
                        type='text'
                        icon={<TbX style={{ color: token.colorTextTertiary }} />}
                        onClick={() => setOpen(false)}
                    />
                }
            />
            <div style={{ minHeight: 0, flex: 1, padding: '1rem' }}>
                {view === 'add' ? (
                    <CreateOAuthApplication setOpen={setOpen} onCreated={onCreated} />
                ) : (
                    <ManageOAuthApplications />
                )}
            </div>
        </div>
    );
};

export default Content;
